module.exports = __webpack_public_path__ + "img/avatar.5855a832.png";